import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from '../../components/TopNav';
import Footer from '../../components/Footer';
import CatchImage from '../../images/catch/catch_flow.jpg';
import CatchImage2x from '../../images/catch/catch_flow@2x.jpg';
import { useTitle } from '../../hooks/useTitle';
import { useMetaDescription } from '../../hooks/useMetaDescription';

const FlowPage: React.FC = () => {
  useTitle('Ton Bébé | 精子提供の流れ');
  useMetaDescription('Ton Bébéでの精子提供の流れを解説。ドナー探しからメッセージ交換、面談、条件確認、精子提供、実績登録承認までの6ステップをご紹介します。');

  return (
    <>
      <header>
        <TopNav />
        <div className="catch sub">
          <img
            src={ CatchImage }
            srcSet={ `${ CatchImage } 1x, ${ CatchImage2x } 2x` }
            alt="精子提供の流れ"
          />
        </div>
      </header>
      <main className="sub">
        <section className="flow">
          <h1 className="sec_title">精子提供の流れ</h1>
          <ul className="text_list">
            <li>
              <h2 className="main_title"><span>1. ドナーを探す</span></h2>
              <p>Ton Bébéには誰かの役に立ちたい、という思いでご登録していただいているドナーがたくさんおります。地域・血液型などの条件や精子検査の結果などからご自身の希望のドナーを探しましょう。</p>
            </li>
            <li>
              <h2 className="main_title"><span>2. メッセージ交換</span></h2>
              <p>初めての人と話すのは緊張しますが、いつでもやめることができますので、軽い気持ちでメッセージを送ってみてください。LINE IDやZoomのリンクも送ることができますので、実際に会話してみるのも良いでしょう。</p>
              <p>ご自身の条件に合っていることが確認できたのち、提供場所・提供方法・実費負担などのドナーの条件を確認しましょう。</p>
            </li>
            <li>
              <h2 className="main_title"><span>3. 面談</span></h2>
              <p>
                実際に精子提供を受ける前に、実際に会ってコミュニケーションをとる機会を持ちましょう。<br/>相手のことを知ることで、お互いに信頼感や安心感を得られ、この後の活動がスムーズに進むことでしょう。<br/>性病や精子検査の結果、その他の証明書も面談の場で確認するようにしましょう。<br/>※会う場所はカフェやホテルのロビーなど人目のある場所にしてください。
              </p>
            </li>
            <li>
              <h2 className="main_title"><span>4. 条件の確認</span></h2>
              <p>
                提供日時や方法について希望を伝えた上でドナーと条件を相互に確認して合意しましょう。<br/>交通費などの実費負担について、ドナーの希望はプロフィールに記載がありますので両者で相談の上で決めましょう。
              </p>
            </li>
            <li>
              <h2 className="main_title"><span>5. 精子提供</span></h2>
              <p>事前に取り決めた日時、場所、方法で精子提供を行います。<br/>精子提供の方法については<Link to="/method">こちら</Link>を参考にしてください。</p>
            </li>
            <li>
              <h2 className="main_title"><span>6. 実績登録承認</span></h2>
              <p>
                提供実績はドナーのプロフィールに回数で表示されます。精子提供が行われると、後日、女性にドナーより承認依頼が届きます。<br/>ドナーの方の今後の活動の助けになりますので、提供を受けた女性は快く承認しましょう。<br/>※提供実績は回数のみ表示され、提供を受けた女性が公開されることはありません
              </p>
            </li>
          </ul>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default FlowPage;
